import { render, staticRenderFns } from "./CartaoAplicacao.vue?vue&type=template&id=1d5d94f0&scoped=true"
import script from "./CartaoAplicacao.vue?vue&type=script&lang=js"
export * from "./CartaoAplicacao.vue?vue&type=script&lang=js"
import style0 from "./CartaoAplicacao.vue?vue&type=style&index=0&id=1d5d94f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5d94f0",
  null
  
)

export default component.exports